import styled from "styled-components/macro";

import {useParams} from "react-router-dom";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import {useFeedback} from "../../store/feedback";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import {useWiki} from "../../api/wiki";
import TextContent from "../../components/text_content";
import {useRelativeTime} from "../../store";
import {isPseudoCommunity} from "../../store/communites";
import CommunityInfo from "../../components/community_info";

const Updated = styled.div``;

const Wiki = styled(({className, index}) => {

    const baseCommunity = useBaseCommunity();
    const {slug, community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);

    const {feedbackCh} = useFeedback();
    const wiki = useWiki(feedbackCh, community, slug);
    const ago = useRelativeTime(wiki?.created, true);

    return (
        <div className={className}>
            <HeaderData title='Wiki' community={community} community_style={style}/>
            <Header>
                <TopBar page={'Community Wiki'} />
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        <CommunityInfo desktop community={community} />
                    </>
                }
            </Header>
            <Container>
                <Wrapper>
                    <Main>
                        {wiki &&
                            <>
                                <TextContent content={wiki.content} />
                                <Updated>Last updated {ago} ago</Updated>
                            </>
                        }
                    </Main>
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={community} />
            </Container>
            <Footer />
        </div>
    );
})`
  ${Main} {
    padding: 16px;
  }

  ${Updated} {
    font-size: 14px;
  }
`;

export default Wiki;
